import { extend } from "vee-validate";
import { Guid } from "guid-typescript";
import { required, email, min, min_value, max, numeric, size, oneOf, between, alpha_spaces, ext, excluded, confirmed, double, regex, is_not } from "vee-validate/dist/rules";
// BUILT-IN VALIDATION RULES
// https://logaretm.github.io/vee-validate/guide/rules.html#rules
extend("required", {
    ...required,
    message: "{_field_} is required",
});
extend("email", {
    ...email,
    message: "Email address is invalid",
});
extend("double", {
    ...double,
    message: "{_field_} is invalid",
});
extend("regex", {
    ...regex,
    message: "{_field_} is invalid",
});
extend("min", {
    ...min,
    message: "Field is too short",
});
extend("min_value", {
    ...min_value,
    message: "{_field_} must be greater than 0.",
});
extend("max", {
    ...max,
    message: "Field is too long",
});
extend("numeric", {
    ...numeric,
    message: "Field allows numbers only",
});
extend("size", {
    ...size,
    message: "File should not exceed {size} KiloBytes.",
});
extend("isNot", {
    ...is_not,
    message: "{_field_} selection is required",
});
extend("oneOf", {
    ...oneOf,
    message: "Selection is mandatory",
});
extend("excluded", {
    ...excluded,
    message: "Selection is mandatory",
});
extend("between", {
    ...between,
    message: "The {_field_} value must be between {min} and {max}",
});
extend("alpha_spaces", {
    ...alpha_spaces,
    message: "Only characters and spaces allowed",
});
extend("answer", {
    ...required,
    message: "An answer is required",
});
extend("ext", {
    ...ext,
    message: "Only PDF, doc and docx format are allowed.",
});
extend("confirmed", {
    ...confirmed,
    message: "Both Passwords do not match.",
});
extend("daterangecheck", {
    validate: (value) => {
        var startDate = value[0];
        var endDate = value[1];
        return startDate instanceof Date && endDate instanceof Date;
    },
    message: "{_field_} should contain at least 2 valid datetimes.",
});
extend("datecheck", {
    validate: (inputDate) => {
        return inputDate instanceof Date;
    },
    message: "{_field_} should contain a date.",
});
// CUSTOM VALIDATION RULES
extend("guidNotEmpty", {
    validate: (value) => {
        if (typeof value == "object") {
            return !value.isEmpty();
        }
        var selectedVal = Guid.parse(value);
        return !selectedVal.isEmpty();
    },
    message: "{_field_} is required",
});
extend("phone", {
    validate: (value) => {
        var exp1 = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
        var exp2 = /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/;
        return exp1.test(value) || exp2.test(value);
    },
    message: "{_field_} is not valid",
});
//extend('is_earlier', {
//    validate: (value, { compare }) => {
//        return date_compare({ value, compare, validationType: 'earlier' });
//    },
//    params: ['compare', 'dateType'],
//    message: 'The selected date must not be earlier than {dateType}'
//});
//extend('is_beyond', {
//    validate: (value, { compare }) => {
//        return date_compare({ value, compare, validationType: 'beyond' });
//    },
//    params: ['compare', 'dateType'],
//    message: 'The selected date must not be older than {dateType}'
//});
